export default "__VITE_ASSET__ddHTlvGa__"